<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminUniteMobileForm from '@/components/admin/uniteMobile/AdminUniteMobileForm.vue'
import { AloDbUniteMobile } from '@/models/alodb/AloDbUniteMobile'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminUniteMobile',
  components: {AdminUniteMobileForm}
})
export default class AdminUniteMobile extends AdminForm<AloDbUniteMobile> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MOBIL_UNIT].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName() {
    return "UniteMobile"
  }

  get originalLibelle() {
    return this.original.UMB_LIBELLE
  }

}
</script>